module.exports = __webpack_public_path__ + "img/biying_pink.ba3d140a.png";